module.exports = __webpack_public_path__ + "static/media/EHS-Service-Users-Handbook-Domicilary.98f2aa80.pdf";